import api from ".";


export const getPlans = (params = {}, callBack) => {
    api.get(`/plans/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const getSubscriptionStatus = (params = {}, callBack) => {
    api.get(`/subscription/status/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const CreateSubscription = (data, callBack) => {
    api.post(`/subscription/create/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const UpdateSubscription = (data, callBack) => {
    api.post(`/plans/change/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};




